// extracted by mini-css-extract-plugin
export default {"container":"Subheader_container__FNrOn","item":"Subheader_item__vrdOF"};